<template>
    <div>
        <b-card no-body
                border-variant="ep"
                header="Relatie"
                header-bg-variant="ep"
                header-text-variant="white"
                class="mb-3 timeline-box">
            <b-list-group flush>
                <b-list-group-item>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="company">Organisatie: *</label>
                                <div :class="isInvalid('ev-organisation')">
                                    <afas-company-input :form="form" ref="afasCompanyInput" v-model="field.organisation" :hideSelect="typeof field.organisation === 'object' && field.organisation !== null"></afas-company-input>
                                    <div v-if="isInvalid('ev-organisation')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-organisation'].join(', ')}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="contact">Contactpersoon: *</label>
                                <div :class="isInvalid('ev-contact')">
                                    <afas-contact-input :form="form" ref="afasContactInput" v-model="field.contact" :organisation="field.organisation" :hideSelect="hideContactPersonSelect()"></afas-contact-input>
                                    <div v-if="isInvalid('ev-contact')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-contact'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>

            <div slot="footer" v-if="createMode || (JSON.stringify(field) !== JSON.stringify(form.event))">
                <div class="d-flex justify-content-end align-items-center ">
                    <div class="text-right">
						<div class="btn-group">
							<button class="btn btn-light" @click="update()" :disabled="!field.organisation || !field.contact">
								<span v-if="createMode">NV-lead opslaan</span>
								<span v-else>Opslaan</span>
							</button>
						</div>
                    </div>
                </div>
            </div>
        </b-card>

		<div v-if="!createMode && refCode && hasOffer && availability.noAvailability && !availability.hideNoAvailabilityAlert" class="alert alert-warning fade show" role="alert">
			<div class="row">
				<div class="col-lg-10">
					<strong>Let op!</strong> Deze gewenste locatie (en/of eventuele zalen) zijn voor de gewenste datum niet beschikbaar. Neem contact op om alternatieve mogelijkheden te bespreken.
				</div>

				<div class="col-lg-2">
					<a class="btn alert-btn btn-light btn-sm ml-2" @click="availability.hideNoAvailabilityAlert = true" aria-label="Sluiten">
						<i class="fas fa-times"></i>
					</a>

					<a class="btn alert-btn btn-light btn-sm" @click="checkAvailability()" aria-label="Vernieuwen">
						<i class="fa fa-sync" :class="{'fa-spin': availability.loadingAvailability}"></i>
					</a>
				</div>
			</div>
		</div>

		<div v-if="!createMode && refCode && !hasOffer && !availability.hideNoAvailabilityAlert" class="alert alert-secondary fade show" role="alert">
			<div class="row">
				<div class="col-lg-10">
					In deze fase van de aanvraag kan de beschikbaarheid nog niet worden gecontroleerd.
				</div>

				<div class="col-lg-2">
					<a class="btn alert-btn btn-light btn-sm ml-2" @click="availability.hideNoAvailabilityAlert = true" aria-label="Sluiten">
						<i class="fas fa-times"></i>
					</a>

					<a class="btn alert-btn btn-light btn-sm" @click="checkAvailability()" aria-label="Vernieuwen">
						<i class="fa fa-sync" :class="{'fa-spin': availability.loadingAvailability}"></i>
					</a>
				</div>
			</div>
		</div>

        <wizard-frame
			v-if="!createMode && refCode"
			:refCode="refCode"
			:hasOffer="hasOffer"
			:availability="availability"
			:key="'wizard-frame-' + $route.params.leadId"
			:isValidForEp="isValidForEp"
			@save="saveToEp"
			@triggerAvailabilityCheck="checkAvailability()"
			@clickedNoAvailabilityText="availability.hideNoAvailabilityAlert = false"
		/>

        <accountmanager-select ref="accountmangerModel" @selected="saveToEp"></accountmanager-select>
    </div>
</template>

<script>
    import formKeys from './../../helpers/formKeys';
    import afasCompanyInput from './../input/afasCompanyInput';
    import afasContactInput from './../input/afasContactInput';
    import AccountmanagerSelect from "./accountmanagerSelect";
    import { EventBus } from './../../helpers/event-bus.js';
    import EpContactMomentCategorySelect from "../input/epContactMomentCategorySelect";
    import wizardFrame from "./wizardFrame";

    export default {
        components: {
            EpContactMomentCategorySelect,
            AccountmanagerSelect,
            afasCompanyInput,
            afasContactInput,
            wizardFrame
        },
        props: {
            form: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                input: {
                    accepted: false
                },
                importantFieldsData: null,
                validationErrors: [],
                field: {},
				originalEventObject: {},
                contactMoment: {
                    type: 2,
                    content: ''
                },
                validationErrorsContactMoment: {},
                refCode: null,
                hasOffer: false,
                isValidForEp: false,
				availability: {
					loadingAvailability: true,
					noAvailability: false,
					hideNoAvailabilityAlert: false
				}
			}
        },
        watch: {
            form(newForm, oldForm) {
                if (newForm !== oldForm) {
                    this.form = newForm;
                    this.setupEventForm();
                }
            }
        },
		mounted() {
            if (this.form) {
                this.setupEventForm();
            }
        },
        computed: {
            createMode() {
				if(this.form !== undefined && this.form.id !== undefined && this.form.id !== null) {
					return !this.form.id
				}

				return false;
            },
            importantFields() {
                this.importantFieldsData = formKeys.findRelevantData(this.form.values);
                return this.importantFieldsData;
            },
			contactPerson() {
				return this.field.contact;
			}
        },
        methods: {
            setupEventForm() {
				let event = Object.assign({}, this.form.event);
				let originalEventObject = Object.assign({}, this.form.event);

                if(formKeys.data.$store === null) {
                    formKeys.data.$store = this.$store;
                }

                if(!event.hasOwnProperty('contactInfo')) {
                    event.contactInfo = '';
                }

                this.field = event;
				this.originalEventObject = originalEventObject;

                if (this.form && this.form.refcode_object) {
                    this.refCode = this.form.refcode_object.code;
                    this.hasOffer = this.form.refcode_object.offer_id && this.form.refcode_object.offer_id !== null;
                }

				this.validateForEp();
				this.checkAvailability();
            },
            hideContactPersonSelect () {
				return (this.field.contact !== undefined && this.field.contact !== null && this.field.contact.length !== 0);
            },
            validate(set = false) {
                let err = [];
                if(this.field.organisation === undefined || this.field.organisation === null) {
                    err['ev-organisation'] = [
                        'Kies een organisatie!'
                    ];
                }
                if(this.field.contact === undefined || this.field.conact === null) {
                    err['ev-contact'] = [
                        'Kies een contactpersoon!'
                    ];
                }
                if(set) {
                    this.validationErrors = err;
                }
                return Object.keys(err).length === 0;
            },
            update() {
                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met opslaan',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                let params = Object.assign({}, this.form);
                params.event = this.field;
                params.createRefcode = true;

                let request = null;
                let mode = 'update';

                if(!this.form.id) {
                    if(params.event.contact) {
                        this.form.values.email = params.event.contact.email;
                        this.form.values.phone = params.event.contact.tel;
                    }
                    if(params.event.organisation) {
                        if(!this.form.values.email) {
                            this.form.values.email = params.event.organisation.email;
                        }
                        if(!this.form.values.phone) {
                            this.form.values.phone = params.event.organisation.tel;
                        }
                    }
                    request = axios.post('/api/v1/leads/form', params);
                    mode = 'create';
                } else {
                    request = axios.put('/api/v1/leads/form/' + this.form.id + '/update', params);
                }

                request
                    .then(response => {
                        let formSaved = response.data;
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: this.form.id ? 'Lead is bijgewerkt!' : 'Lead is opgeslagen!',
                            showConfirmButton: false,
                            timer: 2000
                        });

                        this.$emit('refCode', response.data.params.refCode);

                        if(mode==='create' && this.contactMoment.content.length > 0) {
                            this.addContactMoment(response.data.id);
                        }
                        else if(!this.form.id) {
                            this.goTo(response.data.id);
                        }else{
							this.$emit('refresh', true);
						}
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            validateForEp() {
                let errors = 0;

                if(this.form.event.organisation === undefined || this.form.event.organisation === null || this.form.event.organisation.length === 0) {
                    errors++;
                }
                if(this.form.event.contact === undefined || this.form.event.contact === null || this.form.event.contact.length === 0) {
                    errors++;
                }

                this.isValidForEp = (errors === 0);
            },
            preSaveToEp() {
                // if (!this.validateForEp(true)) {
                //     return;
                // }

                this.selectAccountmanager();
            },
            selectAccountmanager() {
                this.$refs.accountmangerModel.show();
            },
            saveToEp(accountmanager) {
                // if(!this.validateForEp(true)) {
                //     return;
                // }
                this.$emit('refresh', true);
                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met toevoegen',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                // this.field.accountmanager = accountmanager.id;
                let params = Object.assign({}, this.form);
                params.event = this.field;
                params.notifyCustomer = true;
                axios.put('/api/v1/leads/events/'+ this.form.id, params)
                    .then(response => {
                        let formSaved = response.data;
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: 'Evenement is toegevoegd!',
                            text: 'Het evenement kan worden gevonden in EasyParty met reserveringsnummer: ' + formSaved.ep_nr,
                            showConfirmButton: false,
                            timer: 3000,
                        });
                        this.$emit('updated', formSaved);
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            validateContactMoment(set = false) {
                let err = [];
                if(this.contactMoment.type === undefined || this.contactMoment.type === null) {
                    err['cm-type'] = [
                        'Kies een type'
                    ];
                }
                if(this.contactMoment.content === undefined || this.contactMoment.content === null) {
                    err['cm-content'] = [
                        'Kies een contactpersoon!'
                    ];
                }
                if(set) {
                    this.validationErrorsContactMoment = err;
                }
                return Object.keys(err).length === 0;
            },
            isInvalidContactMoment(key) {
                if(this.validationErrorsContactMoment.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            addContactMoment(id, goto) {
                if(!this.validateContactMoment(true)) {
                    return;
                }

                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met toevoegen van contactmoment',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                axios.post('/api/v1/leads/form/' + id + '/contactmoment', this.contactMoment)
                    .then(response => {
                        let formSaved = response.data;
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: 'Contactmoment is toegevoegd!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        this.goTo(id);
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            isInvalid(key) {
                if(this.validationErrors.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            goTo(id) {
                EventBus.$emit('refresh-list');
                this.$router.replace({name: 'nv-lead.details', params: {leadId: id}})
            },
			checkAvailability() {
				this.availability.loadingAvailability = true;

				if(this.refCode !== undefined && this.refCode && this.hasOffer !== undefined && this.hasOffer) {
					axios.get('/api/v1/leads/form/' + this.refCode + '/availability')
						.then(response => {
							this.availability.loadingAvailability = false;
							this.availability.noAvailability = !response.data.available;
						})
						.catch(error => {
							this.$swal({
								type: 'error',
								showConfirmButton: false,
								html: this.$errorMessage(error)
							});
							this.availability.loadingAvailability = false;
						});
				}else{
					let thisRef = this;
					setTimeout(function() {
						thisRef.availability.loadingAvailability = false;
					}, 1000);
				}
			}
        }
    }
</script>

<style lang="scss">
    .form-details {
        .heading {
            .title {
                font-size: 1.2em;
            }
        }
        .sub-title {
            font-weight: bolder;
            text-transform: uppercase;
            text-space: 2;
        }
        .description-textarea {
            min-height: 90px;
            height: auto;
            max-height: auto;
        }
    }
    .contactInfo {
        min-height: 105px;
    }

	.alert {
		width: 100%;
		float: left;
	}

	.alert .alert-btn {
		float: right;
		background: red;
		width: 30px;
		background: none;
	}
</style>